import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { colorScheme } from 'src/app/shared/constants/static-variable';
import { PricePipe } from 'src/app/shared/pipe/price.pipe';
import { CommonService } from 'src/app/shared/services/angular-service/common.services';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';

@Component({
  selector: 'app-company-financial',
  templateUrl: './company-financial.component.html',
  styleUrls: ['./company-financial.component.scss'],
})
export class CompanyFinancialComponent implements OnInit {
  @Output() itemAddedToCart: EventEmitter<any> = new EventEmitter();

  @Input() cin: any;
  @Input() all_data;
  public length: any;
  fragment: any;
  productList: any;
  onSession: any;
  totalRevenue: any;
  revenueData: any;
  totalOperatingRevenue: any;
  customRevenueData: any;
  totalExpense: any;
  expenseData: any;

  constructor(
    private localStorageService: LocalStorageService,
    private router: ActivatedRoute,
    private tansactionService: TansactionService,
    private toastService: ToastService,
    private commonService: CommonService,
    private loginSignupService: LoginSignupService,
    private route: Router,
  ) { }

  financialChartData: any[] = [];
  shareHolderData: any[] = [];
  showDetails: boolean = false;
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  showYAxisLabel = true;
  showLabels = true;
  view = [400, 200];
  maxLabelLength = 20;

  colorScheme2 = {
    domain: ['#0066FF', '#1F78B4', '#111111'],
  };

  colorScheme3 = {
    domain: [
      '#0066FF',
      '#111111',
      '#1F78B4',
      '#0C87F9',
      '#1a1aff',
      '#1aa3ff',
      ' #3366ff',
      ' #4db8ff',
      '#0000e6',
      '#4da6ff',
    ],
  };
  colorScheme4 = {
    domain: [
      '#0066FF',
      '#1F78B4',
      '#0C87F9',
      '#1a1aff',
      '#1aa3ff',
      ' #3366ff',
      ' #4db8ff',
      '#0000e6',
      '#4da6ff',
      '#0000cc',
      '#80b3ff',
      '#0000ff',
    ],
  };
  colorScheme5 = colorScheme;
  colorScheme = colorScheme;
  colorScheme1 = colorScheme;

  isPremium = false;
  plan: any;
  isAdvance = false;
  isFree = false;

  companyFinancial: any;
  financial_list: any[] = [];
  shareHolderList: any[] = [];
  shareHolderList1: any[] = [];
  shareHolderList2: any[] = [];

  financialRevenueData: any[] = [];
  financialRevenueCustomData: any[] = [];
  revenueAssessmentYear: UntypedFormGroup;
  revenuePieChart: any[] = [];
  customRevenuePieChart: any[] = [];

  revenueChangeYear(e) {
    let tempYear = e.target.value;
    // const namesInData = this.financialRevenueData.map(item => item.name);
    // const namesInCustomData = this.financialRevenueCustomData.map(item => item.name);
    const isYear = this.financialRevenueCustomData.some(item => item.name === tempYear);
    this.financialRevenueData.forEach((data) => {
      if (data.name == tempYear) {
        this.revenuePieChart = data?.series;
      }
    });
    this.financialRevenueCustomData.forEach((data) => {
      if (data.name == tempYear) {
        this.customRevenuePieChart = data?.series;
      }
    })
    if (!isYear) {
      this.customRevenuePieChart = [];
    }
    this.getFinancial(tempYear);
    this.getOperatingFinancial(tempYear);
  }

  getFinancial(year) {
    const yearData = this.financialRevenueData.find(item => item.name === year);
    if (yearData) {
      this.totalRevenue = yearData.series.reduce((sum, revenue) => sum + revenue.value, 0);
    }
    this.extractSeriesData(year);
  }

  getOperatingFinancial(year) {
    const yearData = this.financialRevenueCustomData.find(item => item.name === year);
    if (yearData) {
      this.totalOperatingRevenue = yearData.series.reduce((sum, item) => sum + parseInt(item.value, 10), 0);
      this.customRevenueData = yearData.series;
    } else {
      this.totalOperatingRevenue = [];
      this.customRevenueData = [];
    }
  }


  extractSeriesData(year: string) {
    const yearData = this.financialRevenueData.find(item => item.name === year);
    if (yearData) {
      this.revenueData = yearData.series;
      this.totalRevenue = this.revenueData.reduce((sum, revenue) => sum + revenue.value, 0);
    }
  }

  financialExpenseData: any[] = [];
  expenseAssessmentYear: UntypedFormGroup;
  expensePieChart;
  expenseChangeYear(e) {
    let tempYear = e.target.value;
    this.financialExpenseData.forEach((data) => {
      if (data.name == tempYear) {
        this.expensePieChart = data?.series;
      }
    });
    this.getExpenseFinancial(tempYear)
  }


  getExpenseFinancial(year) {
    const yearData = this.financialExpenseData.find(item => item.name === year);
    if (yearData) {
      this.totalExpense = yearData.series.reduce((sum, item) => sum + parseInt(item.value, 10), 0);
    }
    this.expenseData = yearData.series;
  }


  ngOnInit() {
    this.onSession = this.loginSignupService.getUserSession()?.user?.onSession;
    this.router.fragment.subscribe((fragment) => {
      this.fragment = fragment;
    });

    this.revenueAssessmentYear = new UntypedFormGroup({
      ay: new UntypedFormControl('', Validators.required),
    });
    this.expenseAssessmentYear = new UntypedFormGroup({
      ay: new UntypedFormControl('', Validators.required),
    });

    this.plan = this.localStorageService.getItem('plan');
    if (this.plan === 'plan_advance') {
      this.isAdvance = true;
    } else if (this.plan === 'plan_premium') {
      this.isPremium = true;
    } else {
      this.isFree = true;
    }

    if ((this.all_data.cin == 'L72200DL2000PLC108985') || (this.all_data.cin == 'L93030DL2010PLC198141')) {
      this.isPremium = true;
      this.isAdvance = false;
      this.isFree = false;
      this.plan = 'plan_premium';
    }

    this.length = this.all_data.financial_list.length;
    this.companyFinancial = this.all_data;

    this.productList = this.all_data.product_list;
    this.commonService.putProductData(this.all_data.product_list['FFD']);
    // console.log(this.productList);
    let shareHolderList = Object.create(this.all_data.share_holders);
    if (shareHolderList.length > 0) {
      if (shareHolderList[0].blurred == undefined) {
        shareHolderList.forEach((data: any) => {
          let foundUpdate = false;
          let shareHolderResult = {
            name: data?.name,
            value: data?.percent_of_share.replace('%', ''),
          };
          if (!foundUpdate) {
            this.shareHolderData.push(shareHolderResult);
            this.colorScheme.domain.push(
              '#' +
              [...'000000'].map(() => Math.random().toString(16)[2]).join('')
            );
          }
        });
        let tempShareHolderList = Object.create(shareHolderList);
        if (tempShareHolderList.length > 6) {
          const middleIndex = Math.ceil(tempShareHolderList.length / 2);
          this.shareHolderList1 = tempShareHolderList.splice(0, middleIndex);
          this.shareHolderList2 = tempShareHolderList;
        } else {
          this.shareHolderList1 = this.all_data.share_holders;
        }
      }
    }

    this.financial_list = this.all_data.financial_list;
    this.getFinancialGraphData();
  }

  ngAfterViewChecked(): void {
    try {
      if (this.fragment) {
        // document('#' + this.fragment).scrollIntoView();
        document.getElementById(this.fragment).scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }
    } catch (e) { }
  }

  getFinancialGraphData() {
    this.financial_list.forEach((data: any) => {
      let foundUpdate = false;
      let result;
      if (
        data.profit_loss != null &&
        data.profit_loss != 0 &&
        data.profit_loss != -1
      ) {
        result = {
          name: data?.ay,
          series: [
            {
              name: 'Revenue',
              value:
                (data.revenue_operation ? data.revenue_operation : 0) +
                (data.revenue_other ? data.revenue_other : 0),
            },
            {
              name: 'Expense',
              value: data.total_expenses ? data.total_expenses : 0,
            },

            {
              name: 'Profit/Loss',
              value: data.profit_loss ? data.profit_loss : 0,
            },
          ],
        };
      }

      let revenueResult: any = {};
      let customRevenueResult: any = {};

      if (
        data.total_revenue != null &&
        data.total_revenue != 0 &&
        data.total_revenue != -1
      ) {
        revenueResult = {
          name: data?.ay,
          series: [
            {
              name: 'Operating Revenue',
              value: data.revenue_operation ? data.revenue_operation : 0,
            },
            {
              name: 'Other Revenue',
              value: data.revenue_other ? data.revenue_other : 0,
            },
          ],
        };
        if (data.customRevenue) {
          let series = [];
          for (const element of Object.keys(data.customRevenue)) {
            series.push({
              name: data.customRevenue[element].label,
              value: data.customRevenue[element].value
            });
          }
          customRevenueResult = {
            name: data?.ay,
            series: series,
          }
        }
      }

      let expenseResult = {
        name: data?.ay,
        series: [
          {
            name: 'Employee Benefit Cost',
            value: data.employee_benefit ? data.employee_benefit : 0,
          },
          {
            name: 'Finance Cost',
            value: data.finance_costs ? data.finance_costs : 0,
          },
          {
            name: 'Advertisement & Promotion Cost',
            value: data.advertising_promotional_expenses
              ? data.advertising_promotional_expenses
              : 0,
          },
          {
            name: 'Travelling Cost',
            value: data.travelling_conveyance ? data.travelling_conveyance : 0,
          },
          {
            name: 'Commission Paid',
            value: data.commission_paid_other_selling_agents
              ? data.commission_paid_other_selling_agents
              : 0,
          },
          {
            name: 'Transportation & Distribution Cost',
            value: data.transportation_distribution_expenses
              ? data.transportation_distribution_expenses
              : 0,
          },
          {
            name: 'Legal & Professional Fees',
            value: data.auditor_fees ? data.auditor_fees : 0,
          },
          {
            name: 'Cost of materials',
            value: data.csr_expenditure ? data.csr_expenditure : 0,
          },
          {
            name: 'Depreciation',
            value: data.depreciation_depletion_and_amortisation_expense
              ? data.depreciation_depletion_and_amortisation_expense
              : 0,
          },
          {
            name: 'Other Expenses',
            value:
              data.total_expenses -
              (data.employee_benefit +
                data.finance_costs +
                data.advertising_promotional_expenses +
                data.travelling_conveyance +
                data.commission_paid_other_selling_agents +
                data.transportation_distribution_expenses +
                data.auditor_fees +
                data.csr_expenditure +
                data.depreciation_depletion_and_amortisation_expense),
          },
        ],
      };

      if (!foundUpdate) {
        if (result !== undefined && result !== null) {
          this.financialChartData.push(result);

          //expense
          if (expenseResult !== undefined && expenseResult !== null) {
            expenseResult.series = expenseResult.series.filter(
              (a) => a.value != 0
            );
            expenseResult.series = expenseResult.series.sort(
              (a, b) => b.value - a.value
            );
            this.expensePieChart = expenseResult.series;
            this.financialExpenseData.push(expenseResult);
            this.expenseAssessmentYear.patchValue({ ay: expenseResult.name });
          }

          //revenue
          if (
            revenueResult !== undefined &&
            revenueResult !== 0 &&
            revenueResult !== null && Object.keys(revenueResult).length !== 0
          ) {
            revenueResult.series = revenueResult.series.filter(
              (a) => a.value != 0
            );
            revenueResult.series = revenueResult.series.sort(
              (a, b) => b.value - a.value
            );
            this.revenuePieChart = revenueResult.series;
            this.financialRevenueData.push(revenueResult);
            if (customRevenueResult.series) {
              this.financialRevenueCustomData.push(customRevenueResult);
              this.customRevenuePieChart = customRevenueResult.series;
            } else {
              this.customRevenuePieChart = [];
            }
            this.revenueAssessmentYear.patchValue({ ay: revenueResult.name });

          }
        }
      }
    });

    if (this.financialExpenseData.length > 0) {
      this.getExpenseFinancial(this.financialExpenseData[this.financialExpenseData.length - 1].name);
    }

    const latestYearRevenue = this.financialRevenueData[this.financialRevenueData.length - 1]?.name;
    if (this.financialRevenueData.length > 0) {
      this.getFinancial(latestYearRevenue);
    }

    if (this.financialRevenueCustomData.length > 0) {
      this.getOperatingFinancial(latestYearRevenue);
    }
  }

  valueFormatting(value) {
    const filterPipe = new PricePipe();
    // console.log(value);
    if (value <= 10000000) {
      return filterPipe.transform(value, null, true);
    } else {
      return filterPipe.transform(value, 'cr', true);
    }
  }

  nameFormatting(name) {
    return name;
  }

  addToCart(sku) {
    if (
      this.onSession == undefined ||
      this.onSession == '' ||
      this.onSession == null
    ) {
      this.route.navigate(['/user/login']);
    } else {
      let currentOption;
      currentOption = {
        sku: sku,
      };
      this.tansactionService.addProductToCart(currentOption).then(
        (data: any) => {
          if (this.plan === 'plan_premium' || this.plan === 'plan_advance') {
            this.toastService.addSingle(
              'success',
              'Email Sent',
              'Please check your email.'
            );
          } else {
            this.toastService.addSingle(
              'success',
              'Item added to cart',
              'Make payment to complete this transaction.'
            );
          }
        },
        (err) => {
          this.toastService.addSingle('error', 'Error', err.error.message);
        }
      );
    }
  }

  toggleDetails() {
    this.showDetails = !this.showDetails;
  }

  getProductShortName(name) {
    return name.replace(' - ' + name + '.pdf', '');
}

  navigateToIndustryReport(name,sku){
    let isReport = false;
    this.route.navigate([`/company/${this.all_data.name}/product/${this.getProductShortName(name)}/${sku}/${isReport}`]);
  }
}
